














































import { Component, Prop, Vue } from "vue-property-decorator";
import JsonCSV from 'vue-json-csv';

Vue.component('downloadCsv', JsonCSV);

@Component({
  components: {},
})
export default class InventoryExport extends Vue {
  filename = 'inventory';

  @Prop({ default: () => [] }) list !: any;
  @Prop({ default: () => [] }) clients !: any;

  clientName(clientId) {
    const client = (this.clients || []).find((item: any) => item.clientId === clientId);
    return client ? client.clientName : '';
  }

  toRow(item: any) {
    const hasSchedule = !!(item.pm || item.safetyTest);
    return {
      ControlNo: item.ControlNo,
      Manufacturer: item.Manufacturer,
      Model: item.Model,
      Nomenclature: item.Nomenclature,
      SerialNo: item.SerialNo,
      Location: item.Location || item.location,
      PM: item.pm ? 'Yes' : 'No',
      ST: item.safetyTest ? 'Yes' : 'No',
      Frequency: hasSchedule ? item.frequency : '',
      StartingMonth: hasSchedule ? item.startingMonth : '',
      Client: this.clientName(item.clientId),
    };
  }

  sortByControlNo(items: any[]) {
    return [...items].sort((a, b) =>
      String(a.ControlNo || '').localeCompare(String(b.ControlNo || ''), undefined, { numeric: true })
    );
  }

  get allRows() {
    return this.sortByControlNo(this.list).map((item: any) => this.toRow(item));
  }

  get selectedRows() {
    return this.sortByControlNo(this.list.filter((item: any) => item.Selected)).map((item: any) => this.toRow(item));
  }
}
